import { makeAutoObservable } from 'mobx';
import { FAILURE, REQUEST, SUCCESS, UNSET } from '../../constants/status';
class result {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  status = UNSET;
  data = {
    completeTime: '',
    createTime: '',
    jobId: 27,
    param: {},
    result: null,
    status: 'success',
  };
  request = () => {
    this.status = REQUEST;
  };
  request_success = (dataInject) => {
    this.data = dataInject;
    this.status = SUCCESS;
  };
  request_fail = () => {
    this.status = FAILURE;
  };
}
export default result;
